import styled from "@emotion/styled"
import { FlexContainer, FlexContainerAndItem } from "../../../styled/flexbox.styled"

export const FundamentalsDisplayContainer = styled(FlexContainer)({
  gridArea: "content",
  height: "100%",
  width: "100%",
  padding: "15px",
})

export const FundamentalsDisplayHeader = styled(FlexContainer)({
  width: "100%",
  margin: "5px",
})

export const FundamentalsDisplayHeaderLeft = styled(FlexContainerAndItem)({
  width: "30%",
  alignItems: "center",
})

export const FundamentalsDisplayHeaderRight = styled(FlexContainerAndItem)({
  alignItems: "center",
  paddingRight: "20px",
})

export const FundamentalsGridContainer = styled(FlexContainerAndItem)({
  width: "100%",
})
